<div class="modal-container">
    <div class="modal-header">
        <h2>{{ 'profile.change-password' | translate }}</h2>
        <button class="close-btn" (click)="onCancel()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="modal-content">
        <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="change-password-form" id="change-password-form">
            <div class="form-group">
                <label for="password">{{ 'profile.current-password' | translate }}</label>
                <div class="password-input-container">
                    <input 
                        [type]="showCurrentPassword ? 'text' : 'password'" 
                        id="password" 
                        class="form-control" 
                        autocomplete="off" 
                        formControlName="currentPassword"
                        [class.invalid]="passwordForm.get('currentPassword')?.invalid && passwordForm.get('currentPassword')?.touched">
                    <button type="button" (click)="toggleCurrentPasswordVisibility()" class="toggle-password" aria-label="Toggle Current Password">
                        <mat-icon>{{ showCurrentPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <div class="error-message" *ngIf="passwordForm.get('currentPassword')?.invalid && passwordForm.get('currentPassword')?.touched">
                        {{ getErrorMessage('currentPassword') }}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="new-password">{{ 'profile.new-pass' | translate }}</label>
                <div class="new-password-input-container">
                    <input 
                        [type]="showNewPassword ? 'text' : 'password'"
                        id="new-password" 
                        class="form-control" 
                        autocomplete="off" 
                        formControlName="newPassword"
                        [class.invalid]="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched"
                    >
                    <button type="button" (click)="toggleNewPasswordVisibility()" class="toggle-new-password" aria-label="Toggle New Password">
                        <mat-icon>{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <div class="error-message" *ngIf="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched">
                        {{ getErrorMessage('newPassword') }}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="confirm-password">{{ 'profile.confirm-pass' | translate }}</label>
                <div class="confirm-password-input-container">
                    <input 
                        [type]="showConfirmPassword ? 'text' : 'password'"
                        id="confirm-password" 
                        class="form-control" 
                        autocomplete="off" 
                        formControlName="confirmPassword"
                        [class.invalid]="passwordForm.get('confirmPassword')?.invalid && passwordForm.get('confirmPassword')?.touched"
                    >
                    <button type="button" (click)="toggleConfirmPasswordVisibility()" class="toggle-confirm-password" aria-label="Toggle Confirm Password">
                        <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <div class="error-message" *ngIf="passwordForm.get('confirmPassword')?.invalid && passwordForm.get('confirmPassword')?.touched">
                        {{ getErrorMessage('confirmPassword') }}
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions">
        <button type="button" (click)="onCancel()" class="cancel-btn" aria-label="Cancel">
            {{ 'buttons.cancel' | translate }}
        </button>
        <button 
            type="button" 
            (click)="onSubmit()"
            [disabled]="!passwordForm.valid"
            class="update-password-btn"
            [class.disabled]="!passwordForm.valid"
            aria-label="Update Password"
        >
            {{ 'buttons.update-password-button' | translate }}
        </button>
    </div>
</div>